import React from 'react';
import { Award } from 'lucide-react';
import { BsTypeH6 } from 'react-icons/bs';
import teamcollabaration from '../../assets/idlbay-team-collaboration-2025.jpg';

const OurStorySection = ({ colors, sectionRef, visibleSections, showFullIntro, toggleIntro }) => {
  return (
    <section 
      className="py-5 performance-optimized" 
      ref={sectionRef} 
      style={{ backgroundColor: colors.white }}
      data-section="story"
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div 
              className={`border-start border-4 ps-4 mb-4 smooth-reveal ${visibleSections.story ? 'revealed' : ''}`} 
              style={{ borderColor: `var(--color-primary) !important` }}
            >
              <h2 className="h3 mb-3 fw-bold" style={{ color: `var(--color-primary)` }}>Our Story</h2>
              <h3 className="display-6 fw-bold mb-4" style={{ color: colors.bodyBlack }}>IDLBAY PRIVATE LIMITED</h3>
            </div>
            
            <div className={`smooth-reveal delay-200 ${visibleSections.story ? 'revealed' : ''}`}>
              <h6 className="mb-4" style={{ color: colors.gray }}>
                At IDLBAY, we are dedicated to empowering businesses through cutting-edge IT solutions and services. 
                With a focus on innovation, quality, and client satisfaction, we partner with you to navigate the 
                complexities of the digital landscape and achieve your strategic objectives.
              </h6>
              <h6 className="mb-4" style={{ color: colors.gray }}>
                Your Digital Future Starts Here. From bespoke web and mobile applications to robust ERP and CRM systems, 
                we empower businesses with technology that drives growth and efficiency.
              </h6>
            </div>
            
            {showFullIntro && (
              <div className="smooth-reveal revealed">
                <h6 className="mb-4" style={{ color: colors.gray }}>
                  <strong style={{ color: colors.bodyBlack }}>Our Mission:</strong> To empower businesses with transformative IT solutions that drive growth, 
                  enhance efficiency, and foster innovation. We strive to be a trusted partner in navigating the 
                  complexities of the digital landscape.
                </h6>
                
                <h6 className="mb-4" style={{ color: colors.gray }}>
                  <strong style={{ color: colors.bodyBlack }}>Our Vision:</strong> We envision a future where technology seamlessly integrates with every 
                  business operation, creating intelligent, agile, and sustainable enterprises. IDLBAY is dedicated to 
                  pioneering this future through continuous technological advancement and unparalleled client service.
                </h6>
                
                <h6 className="mb-4" style={{ color: colors.gray }}>
                  We believe in fostering a dynamic and supportive work environment where talent thrives. We empower our 
                  employees to innovate, learn continuously, and make a significant impact on real-world IT challenges.
                </h6>
              </div>
            )}
            
            <button 
              className={`btn btn-animated smooth-reveal delay-300 ${visibleSections.story ? 'revealed' : ''}`}
              style={{ 
                backgroundColor: `var(--color-primary)`,
                color: colors.white,
                border: 'none'
              }}
              onClick={toggleIntro}
            >
              {showFullIntro ? 'Show Less' : 'Learn More'}
            </button>
          </div>
          
          <div className="col-lg-6">
            <div className={`position-relative image-hover-zoom smooth-reveal delay-400 ${visibleSections.story ? 'revealed' : ''}`}>
             <img 
  src={teamcollabaration} 
  alt="IDLBAY software development team collaboration meeting"
  title="IDLBAY Team Collaboration 2025"
  className="img-fluid"
  loading="lazy" 
  width="600"    
  height="400"
  style={{
    borderTopLeftRadius: "120px",
    borderBottomRightRadius: "120px",
  }}
/>
              <div 
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center" 
                style={{
                  width: '80px', 
                  height: '80px', 
                  transform: 'translate(20px, -20px)',
                  backgroundColor: `var(--color-primary)`,
                  color: colors.white,
                  borderTopLeftRadius: "20px",
                  borderBottomRightRadius: "20px",
                  // margin: "10px",
                  // borderBottomLeftRadius: "20px",
                  margin: "20px"
                  
                }}
              >
                <Award size={32} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStorySection;